module.exports = __webpack_public_path__ + "img/reasons_banner.52be6e9b.jpg";